export type VoidCallback = () => void;
export type DataCallback<T> = (value: T) => void;
export type UpdateDataCallback<T> = (value: T) => T;
export type UpdateDataCallbackAsync<T> = (value: T) => T | Promise<T>;

export type GetterFn<T> = () => T;
export type SetterFn<T> = (value: T) => void;
export type UpdaterFn<T> = (value: T) => T;
export type ComparerFn<T> = (prev: T, curr: T) => boolean;
export type MapperFn<S, T> = (value: S) => T;
export type FactoryFn<T> = GetterFn<T>;

export type CustomChangeEvent<T> = { target: { name: string; value: T } }
export type CustomChangeEventHandler<T> = SetterFn<CustomChangeEvent<T>>;

export enum ServerProviderType {
  MSTeams = 'MSTeams',
  PCA = 'PCA',
  RingCentral = 'RingCentral',
  TAPI = 'TAPI',
  CSTA = 'CSTA',
}

export enum ConnectorTypes {
  Avaya = 'Avaya',
  Zoom = 'Zoom',
}